import React from "react";
import { Box, IconButton, SxProps, Theme, Typography } from "@mui/material";
import { Accept, useDropzone } from "react-dropzone";
import { Close } from "@mui/icons-material";

interface FileUploadProps {
  text?: string;
  files?: File[];
  accept?: Accept;
  multiple?: boolean;
  sx?: SxProps<Theme>;
  onAddFile?: (file?: File[]) => void;
}
export const FileUpload: React.FC<FileUploadProps> = ({ sx, onAddFile, text, files, accept, multiple }) => {
  // Configuração do dropzone
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (onAddFile) onAddFile(acceptedFiles);
    },
    accept: accept,
    multiple: multiple,
  });

  return (
    <Box sx={{
      display: "flex",
      overflowY: "auto",
      alignItems: "end",
      flexDirection: "column",
      ...sx
    }}>
      {/* Dropzone */}
      <Box
        {...getRootProps()}
        sx={{
          flex: 1,
          display: "flex",
          border: "2px dashed #ccc",
          borderRadius: "15px",
          padding: "15px",
          textAlign: "center",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          backgroundColor: isDragActive ? "#f0f0f0" : "inherit",
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <Typography>Solte o arquivo aqui...</Typography>
        ) : (
          <Typography>
            {text ?? "Arraste um arquivo aqui ou clique para selecionar"}
          </Typography>
        )}
      </Box>

      {/* Texto */}
      {files && <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
        {files.length === 1 && <Typography>Arquivo: {files[0].name}</Typography>}
        {files.length > 1 && <Typography>{`${files.length} arquivos`}</Typography>}
        <div style={{ flex: 1 }} />
        <IconButton size="small" onClick={() => onAddFile && onAddFile(undefined)}>
          <Close fontSize="small" />
        </IconButton>
      </div>}
    </Box>
  );
};
